module.exports = __webpack_public_path__ + "static/img/carousel_6.8858672f.jpg";